module.exports = __webpack_public_path__ + "img/icon-users.47914540.svg";